import PropTypes from 'prop-types';

const propTypes = {
  categories: PropTypes.arrayOf(PropTypes.shape({
    link: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  })),
};
export default propTypes;
